(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function openHorizonCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
    var toggle = document.querySelector('[data-cart-toggle], #cart-icon-bubble, [aria-controls="cart-drawer"]');
    if (toggle && !drawer) toggle.click();
  }

  function handleATC(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    btn.disabled = true;
    btn.setAttribute('data-loading', 'true');
    var originalText = btn.textContent.trim();
    btn.textContent = '';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('cart/add failed: ' + res.status);
      return res.json();
    })
    .then(function () {
      return fetch('/cart?sections=cart-icon-bubble', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (data && data['cart-icon-bubble']) {
          var el = document.getElementById('cart-icon-bubble');
          if (el) {
            var tmp = document.createElement('div');
            tmp.innerHTML = data['cart-icon-bubble'];
            var fresh = tmp.querySelector('#cart-icon-bubble');
            if (fresh) el.replaceWith(fresh);
          }
        }
      });
    })
    .then(function () {
      openHorizonCartDrawer();
      btn.textContent = originalText;
      btn.disabled = false;
      btn.removeAttribute('data-loading');
    })
    .catch(function (err) {
      console.error('[mlf-atc]', err);
      btn.textContent = originalText;
      btn.disabled = false;
      btn.removeAttribute('data-loading');
    });
  }

  function initSection(section) {
    var track   = section.querySelector('[data-mlf-track]');
    var prevBtn = section.querySelector('[data-mlf-prev]');
    var nextBtn = section.querySelector('[data-mlf-next]');
    var atcBtns = section.querySelectorAll('[data-mlf-atc]');

    if (!track) return;

    var scrollAmount = function () {
      var card = track.querySelector('.mlf-card');
      if (!card) return 260;
      return card.offsetWidth + 16;
    };

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });
    }

    atcBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { handleATC(btn); });
    });
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('.mlf-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.mlf-section');
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:reorder', function () { init(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
